const apiUrl = "https://stockist.co/api/v1/u9555/locations/all.js";
let storeData = []; // Declare storeData globally

// Fetch data from the API and convert it to JSON
fetch(apiUrl)
  .then((response) => response.json())
  .then((data) => {
    console.log("Fetched data:", data); // Log the API response to see its structure
    storeData = data; // Store the fetched data
    populateDropdowns(); // Call to populate dropdowns after data is fetched
  })
  .catch((error) => console.error("Error fetching store data:", error)); // Handle any errors

function populateDropdowns() {
  const canadaProvinceSelect = document.getElementById("canada-province");
  const usaStateSelect = document.getElementById("usa-state");

  let canadaProvinces = new Set();
  let usaStates = new Set();

  // Collect provinces for Canada and states for the USA, considering both country names and abbreviations
  storeData.forEach((store) => {
    if (store.country === "Canada" || store.country === "CA") {
      canadaProvinces.add(store.state); // Use state for Canada
    } else if (store.country === "United States" || store.country === "US") {
      usaStates.add(store.state); // Use state for USA
    }
  });

  // Convert to array and sort the provinces and states alphabetically
  const sortedCanadaProvinces = [...canadaProvinces].sort();
  const sortedUsaStates = [...usaStates].sort();

  // Populate the Canada provinces dropdown
  sortedCanadaProvinces.forEach((province) => {
    const option = document.createElement("option");
    option.value = province;
    option.textContent = province;
    canadaProvinceSelect.appendChild(option);
  });

  // Populate the USA states dropdown
  sortedUsaStates.forEach((state) => {
    const option = document.createElement("option");
    option.value = state;
    option.textContent = state;
    usaStateSelect.appendChild(option);
  });

  // Attach event listeners for filtering cities
  canadaProvinceSelect.addEventListener("change", () => filterCities("Canada"));
  usaStateSelect.addEventListener("change", () =>
    filterCities("United States")
  );
}

function filterCities(country) {
  const citySelect =
    country === "Canada"
      ? document.getElementById("canada-city")
      : document.getElementById("usa-city");
  const regionSelect =
    country === "Canada"
      ? document.getElementById("canada-province")
      : document.getElementById("usa-state");

  const selectedRegion = regionSelect.value;
  let cities = new Set();

  citySelect.innerHTML = '<option value="">Select a city</option>'; // Clear previous city options and add default

  storeData.forEach((store) => {
    if (
      (store.country === country ||
        store.country === (country === "Canada" ? "CA" : "US")) &&
      store.state === selectedRegion
    ) {
      cities.add(store.city); // Add the city to the set
    }
  });

  // Convert set to array and sort cities alphabetically
  let sortedCities = [...cities].sort(); // Use a new sorted array

  // Populate cities dropdown
  sortedCities.forEach((city) => {
    const option = document.createElement("option");
    option.value = city;
    option.textContent = city;
    citySelect.appendChild(option);
  });

  // Attach event listener to display filtered stores
  citySelect.addEventListener("change", () => displayStores(country));
}

function displayStores(country) {
  const citySelect =
    country === "Canada"
      ? document.getElementById("canada-city")
      : document.getElementById("usa-city");
  const selectedCity = citySelect.value;
  const storeList =
    country === "Canada"
      ? document.getElementById("store-list-canada")
      : document.getElementById("store-list-usa");

  storeList.innerHTML = ""; // Clear previous store list

  storeData.forEach((store) => {
    if (
      (store.country === country ||
        store.country === (country === "Canada" ? "CA" : "US")) &&
      store.city === selectedCity
    ) {
      let directions = "#"; // Default if no directions provided
      const customFields = store.custom_fields;

      // Check if there is a custom field for directions
      if (customFields && customFields.length > 0) {
        const directionsField = customFields.find(
          (field) => field.name === "Directions"
        );
        if (directionsField) {
          directions = directionsField.value; // Get the directions link
        }
      }

      const storeElement = document.createElement("div");
      storeElement.innerHTML = `
                <h4>${store.name}</h4>
                <p>${store.address_line_1}</p>
                <p>${store.state}, ${store.postal_code}</p>
                <p>${store.country}</p>
                <div class="directions-wrapper"><a href="${directions}" target="_blank">Directions</a></div>
            `;
      storeList.appendChild(storeElement);
    }
  });
}
